import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "sidebar-header" }
const _hoisted_4 = { class: "system-logo" }
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = { class: "sidebar-footer" }
const _hoisted_7 = { class: "user-info" }
const _hoisted_8 = { class: "user-avatar" }
const _hoisted_9 = { class: "user-details" }
const _hoisted_10 = { class: "username" }
const _hoisted_11 = { class: "user-actions" }
const _hoisted_12 = { class: "main-content" }

import { ref, computed, onMounted } from "vue";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { ElMessageBox, ElMessage } from "element-plus";
import router from "../router/index";
import jsCookie from "js-cookie";
import config from "@/config";
import { useStore } from "vuex";
import websocketManager from "@/services/websocketManager";
import { NAVIGATION_MENU_ITEMS } from "@/types/permission";
import { smartLoginCheck, startSilentTokenRefresh } from "@/utils/auth";
// import DataSourceSwitch from '../components/DataSourceSwitch.vue';

// 中文注释：引入全局store

export default /*@__PURE__*/_defineComponent({
  __name: 'NavView',
  setup(__props) {

const {
  Monitor,
  DataBoard,
  Setting,
  Phone,
  User,
  SwitchButton,
  Upload,
  CreditCard,
  Microphone,
  DataAnalysis,
  Box,
  OfficeBuilding,
  Key,
} = ElementPlusIconsVue as any;
const store = useStore();

// 用户信息（从store获取）
const userInfo = computed(() => store.getters.getUser || { username: "admin" });
// 中文注释：优先展示显示名称，其次用用户名
const userDisplayName = computed(() => {
  const u = userInfo.value as any;
  return u?.display_name || u?.username || "admin";
});

// 获取最新的用户信息
onMounted(async () => {
  // 智能登录检查（支持静默token刷新）
  if (config.requireLogin) {
    const canProceed = smartLoginCheck();
    if (!canProceed) return;

    // 启动静默token刷新
    startSilentTokenRefresh();
  }

  try {
    await store.dispatch("fetchUserInfo");
  } catch (error) {
    console.error("获取用户信息失败:", error);
    // 如果获取失败，可能是token过期，跳转到登录页
    router.push("/login");
  }
});
const userRole = computed(() => store.getters.getUserRole);
const showUserManage = computed(() => {
  const role = userRole.value;
  return role === "admin" || role === "super_admin";
});

// 使用集中化的菜单项配置
const allMenuItems = NAVIGATION_MENU_ITEMS;

// 计算当前用户可见菜单项
const menuItems = computed(() => {
  // 中文注释：调试用户角色和菜单过滤逻辑
  console.log("当前用户角色:", userRole.value);
  console.log("所有菜单项:", allMenuItems);

  // 如果用户角色为空，返回所有菜单项（临时容错）
  if (!userRole.value) {
    console.warn("用户角色为空，显示所有菜单项");
    return allMenuItems;
  }

  const filteredItems = allMenuItems.filter((item) =>
    item.roles.includes(userRole.value)
  );
  console.log("过滤后的菜单项:", filteredItems);
  return filteredItems;
});

// 处理下拉菜单命令
const handleCommand = (command: string) => {
  switch (command) {
    case "profile":
      router.push("/profile");
      break;
    case "users":
      router.push("/users");
      break;
    case "logout":
      loginOut();
      break;
  }
};

// 退出系统
const loginOut = () => {
  websocketManager.disconnect(); // 登出时断开 WebSocket
  if (!config.requireLogin) {
    return;
  }
  ElMessageBox.confirm("确定要退出系统吗？", "确认退出", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    jsCookie.remove("userToken");
    jsCookie.remove("username");
    store.dispatch("logout");
    window.dispatchEvent(new CustomEvent("user-logout"));
    ElMessage.success("退出成功");
    router.push("/login");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Monitor))
            ]),
            _: 1
          })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "system-title" }, "康养紧急呼叫系统", -1))
      ]),
      _createElementVNode("nav", _hoisted_5, [
        _createVNode(_component_el_menu, {
          "default-active": _ctx.$route.path,
          class: "nav-menu",
          router: "",
          "background-color": "transparent",
          "text-color": "#1f2d3d",
          "active-text-color": "#0b6b88"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                key: item.path,
                index: item.path
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      (item.path === '/dashboard')
                        ? (_openBlock(), _createBlock(_unref(DataBoard), { key: 0 }))
                        : (item.path === '/deviceManagement')
                          ? (_openBlock(), _createBlock(_unref(Monitor), { key: 1 }))
                          : (item.path === '/callRecords')
                            ? (_openBlock(), _createBlock(_unref(Phone), { key: 2 }))
                            : (item.path === '/ota')
                              ? (_openBlock(), _createBlock(_unref(Upload), { key: 3 }))
                              : (item.path === '/simCardList')
                                ? (_openBlock(), _createBlock(_unref(CreditCard), { key: 4 }))
                                : (item.path === '/recordingManagement')
                                  ? (_openBlock(), _createBlock(_unref(Microphone), { key: 5 }))
                                  : (item.path === '/rtcStats')
                                    ? (_openBlock(), _createBlock(_unref(DataAnalysis), { key: 6 }))
                                    : (item.path === '/packageManagement')
                                      ? (_openBlock(), _createBlock(_unref(Box), { key: 7 }))
                                      : (item.path === '/tenantManagement')
                                        ? (_openBlock(), _createBlock(_unref(OfficeBuilding), { key: 8 }))
                                        : (item.path === '/tenantApiKeys')
                                          ? (_openBlock(), _createBlock(_unref(Key), { key: 9 }))
                                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(User))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(userDisplayName.value), 1),
            _createVNode(_component_el_dropdown, {
              trigger: "click",
              onCommand: handleCommand
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "profile" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(User))
                          ]),
                          _: 1
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" 个人资料 ", -1))
                      ]),
                      _: 1
                    }),
                    (showUserManage.value)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          command: "users"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Setting))
                              ]),
                              _: 1
                            }),
                            _cache[2] || (_cache[2] = _createTextVNode(" 用户管理 ", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      command: "logout"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SwitchButton))
                          ]),
                          _: 1
                        }),
                        _cache[3] || (_cache[3] = _createTextVNode(" 退出登录 ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Setting))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_12, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.fullPath
      }))
    ])
  ]))
}
}

})